export default {
  BOOK_TONIGHT: 'book_tonight',
  RECOMMENDATIONS: 'recommendations',
  CURATED: 'curated',
};

export const BOOK_TONIGHT_ANALYTICS_LIST_ID = 10014;
